module.exports = __webpack_public_path__ + "static/media/img117_R.20d1b26a.jpg";